import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Icons from './components/Icons';

import '../../css/Projects.css';

const Projects = () => {

    useEffect(() => {
        const handleIntersection = (entries) => {
            if (entries[0].isIntersecting) {
                const alphaBanner = document.querySelector('.vAygCK-api-load-alpha-banner');
                if (alphaBanner) {
                    alphaBanner.style.display = 'none';
                }
            }
        };

        const alphaBannerObserver = new IntersectionObserver(handleIntersection);
        const alphaBanner = document.querySelector('.vAygCK-api-load-alpha-banner');
        if (alphaBanner) {
            alphaBannerObserver.observe(alphaBanner);
        }
        return () => {
            alphaBannerObserver.disconnect();
        };
    }, []);

    return (
        <div className='GridPage'>
            <Icons />
            <Outlet />
        </div>
    );
};

export default Projects;
